import IconButton from '@mui/material/IconButton';
import React, { useEffect } from 'react';

import ShareIcon from '@mui/icons-material/Share';
import { Button, Tooltip } from '@mui/material';
import numeral from 'numeral';
import { getProjectShares } from '../api/orders';
import { ShareDataItem } from '../core/global';
import { ProjectItemShareModal } from './project-item-share-modal';


interface ItemShareButtonProps {
  itemId: string | number | null
  type: 'item' | 'project'
}

export const ItemShareButton = ({
  itemId,
  type,
}: ItemShareButtonProps) => {
  const [activeItemId, setActiveItemId] = React.useState<number | string | null>(null)
  const [sharesData, setSharesData] = React.useState<ShareDataItem[] | null>(null)

  useEffect(() => {
    if (!itemId || type !== "project") {
      return
    }

    const refetchShares = async () => {
      const {response} = await getProjectShares({project_id: itemId})
      if (response) {
        const {shares} = response
        setSharesData(shares)
      } else {
        setSharesData(null)
      }
    }
    refetchShares()

  }, [itemId, type])

  if (!itemId) {
    return null
  }

  return (
    <>
    {type === 'item' && (
      <Tooltip
        title={'Share'} 
        placement="bottom" 
        arrow
      >
        <IconButton
          size="small"
          onClick={(e: React.SyntheticEvent) => {
            e.preventDefault()
            setActiveItemId(itemId)
          }}
        >
          <ShareIcon sx={{color: '#000'}} />
        </IconButton>
      </Tooltip>
    )}
    {type === 'project' && (
      <div>
        <Button 
          sx={{
            maxWidth: "240px",
          }}
          variant="contained"
          startIcon={<ShareIcon sx={{color: '#ffffff'}} />}
          onClick={(e: React.SyntheticEvent)=> {
            e.preventDefault()
            setActiveItemId(itemId)
          }}
        >
          {sharesData !== null && sharesData.length === 0 ? 'Share project folder' : 'Manage sharing'}
        </Button>
        {
          sharesData !== null && sharesData.length === 0 && <p style={{margin: "16px 0"}}>Private folder. Only you have access.</p>
        }
        {
          sharesData !== null && sharesData.length > 0 && <p style={{margin: "16px 0"}}>There are <strong>{numeral(sharesData.length).format('0,0')}</strong> other users with access to this project folder.</p>
        }
      </div>
    )}
      {activeItemId && <ProjectItemShareModal onClose={() => setActiveItemId(null)} itemId={activeItemId} type={type} />}
    </>
  )
}
